import { Modal, ModalHeader, ModalBody, Button, Input } from 'reactstrap';
import useTournamentDetails from '@/hooks/useTournamentDetails';
import { useMemo, useState } from 'react';
import SearchablePlayerSelect from './SearchablePlayerSelect';

const MovePlayerModal = ({
  onSubmit,
  onClose,
  title,
  tournamentId,
}: {
  onSubmit: (playerAlias: string, tableId: string) => void;
  onClose: () => void;
  title: string;
  description: string;
  submitText: string;
  tournamentId: string;
}) => {
  const { players, tournamentTables } = useTournamentDetails(tournamentId);

  const [selectedPlayer, setSelectedPlayer] = useState<string | null>(null);
  const [selectedTable, setSelectedTable] = useState<string | null>(null);

  const currentTable = useMemo(() => {
    if (!selectedPlayer || !tournamentTables) return null;

    const player = players?.players?.find((p) => p.userId === selectedPlayer);
    if (!player) return null;

    return tournamentTables.find((table) => table?.players.some((tablePlayer) => tablePlayer.alias === player.alias));
  }, [selectedPlayer, tournamentTables, players]);

  const handleSubmit = () => {
    if (!selectedPlayer || !selectedTable) {
      return;
    }

    const player = players?.players?.find((player) => player.userId === selectedPlayer);
    if (!player) {
      return;
    }

    onSubmit(player.userId, selectedTable);
  };

  return (
    <Modal isOpen toggle={onClose} id="move-player-modal" className="modal-md" centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody className="d-flex flex-column gap-4">
        <div>
          <p className="mb-2">Player</p>
          <SearchablePlayerSelect
            players={players?.players}
            selectedPlayerId={selectedPlayer}
            onPlayerSelect={setSelectedPlayer}
            placeholder="Search for a player to move..."
          />
        </div>

        {currentTable && (
          <div className="alert alert-info" role="alert">
            <strong>Current Table:</strong> {currentTable.table?.name}
          </div>
        )}

        <div>
          <p className="mb-2">To Table</p>
          <Input
            value={selectedTable || ''}
            onChange={(e) => {
              setSelectedTable(e.target.value);
            }}
            type="select"
            name="To Table"
            id="to-table"
          >
            <option value="">Select destination table</option>
            {tournamentTables?.map((table) => {
              return (
                <option key={table.tableId} value={table.tableId}>
                  {table.table?.name} - Players: {table.playerCount} / {table.table?.maxPlayers}
                </option>
              );
            })}
          </Input>
        </div>

        <Button
          disabled={!selectedPlayer || !selectedTable || selectedTable === currentTable?.tableId}
          color="primary"
          onClick={handleSubmit}
        >
          Move Player
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default MovePlayerModal;
